import ieqipCoreServiceApi from './ieqipCoreServiceApi';

export const create503aOperation = (operationData) => {
    return ieqipCoreServiceApi.post('/api/inspections/inspection503aoperations', operationData);
};

export const update503aOperation = (operationData) => {
    return ieqipCoreServiceApi.post('/api/inspections/inspection503aoperations', operationData);
};

// Delete a 503A operation by UID
export const delete503aOperation = (operationUid) => {
    return ieqipCoreServiceApi.delete(`/api/inspections/inspection503aoperations/${operationUid}`);
};

// eslint-disable-next-line
export default {
    create503aOperation,
    update503aOperation,
    delete503aOperation
};
